export default "__VITE_ASSET__D$TvxHZ5__"